"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMenu = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Menu_1 = require("./Menu");
const arrow_1 = require("./arrow");
const PropStopLink = (props) => {
    const stopProp = (e) => {
        if (props.shouldPropStop) {
            e.stopPropagation();
        }
    };
    return (React.createElement("a", { onClick: stopProp, href: `${props.item.link}` }, props.item.name));
};
const ModalMenu = (props) => {
    var _a;
    const context = React.useContext(Menu_1.MenuContext);
    const [submenuVisible, setVisibleSubmenu] = React.useState(null);
    const [reset, setReset] = React.useState(true);
    const openMenu = (e) => {
        e.preventDefault();
        setVisibleSubmenu(null);
        const index = parseInt(e.currentTarget.getAttribute('data-submenu'), 10);
        if (index !== submenuVisible) {
            setVisibleSubmenu(index);
        }
    };
    const hasSubmenu = (item) => {
        return (item.subMenu && item.subMenu.length > 0) || false;
    };
    const stopProp = (e) => {
        e.stopPropagation();
    };
    return (React.createElement(ModalMenuWrap, null,
        React.createElement(MenuElementsWrap, null,
            React.createElement(MenuUl, null, (_a = props.menuelements) === null || _a === void 0 ? void 0 : _a.map((item, index) => {
                var _a;
                return (React.createElement("li", { key: `meny_${index}`, onClick: openMenu, "data-submenu": index },
                    React.createElement("div", { style: { minWidth: '280px' } },
                        React.createElement(PropStopLink, { shouldPropStop: !hasSubmenu(item), item: item }),
                        hasSubmenu(item) && (React.createElement(arrow_1.Arrow, { open: index === submenuVisible }))),
                    React.createElement(SubMenu, null, submenuVisible === index &&
                        ((_a = item === null || item === void 0 ? void 0 : item.subMenu) === null || _a === void 0 ? void 0 : _a.map((item) => (React.createElement("li", null,
                            React.createElement("a", { onClick: stopProp, href: `${item.link}` }, item.name))))))));
            })),
            React.createElement(BottomMenu, null,
                React.createElement("a", { href: "https://privatmegleren.no/personvern" }, "Personvern")))));
};
exports.ModalMenu = ModalMenu;
const ModalMenuWrap = styled_components_1.default.div `
  font-size: 18px;
  color: #fff;
  width: 100%;
  min-height: 100vh;
  padding: 2em 0;
  position: relative;
`;
const MenuUl = styled_components_1.default.ul `
  font-size: 27px;
  color: #fff;
  text-decoration: none;
  list-style: none;
  margin: 16px 0 0;
  padding: 0 0;
  li {
    cursor: pointer;
    margin: 0;
    padding: 0 0 10px 30px;
    text-align: left;
    @media (min-width: 1140px) {
      margin-right: 30px;
      padding: 0 0 10px 0;
    }
  }

  a {
    color: inherit;
    text-decoration: inherit;
    display: inline;
  }
`;
const MenuElementsWrap = styled_components_1.default.div ``;
const BottomMenu = styled_components_1.default.div `
  padding: 0 0;
  margin: 90px 0 0 30px !important;
  text-align: left;

  @media (min-width: 1140px) {
    margin: 90px 0 0 !important;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
`;
const SubMenu = styled_components_1.default.ul `
  margin: 0.5em 0.5em 0 !important;
  padding: 0;
  li {
    list-style-type: none;
    font-size: 16px;
    padding-left: 0;
    padding-bottom: 6px;
  }
`;
//# sourceMappingURL=modal-menu.js.map